
<template>
    <div class="headder">
        <div class="head-cont clear">
            <div class="logo-lk fl">
                <a :href="BASE_URL" class="logo-c">
                    <img v-if="logoUrl" :src="BASE_URL + logoUrl" alt="logo">
                    <img v-else src="../../../../public/logo.png" alt="logo">
                    <!-- <img :src="`${baseUrl}logo.png`" alt=""> -->
                </a>
                <a v-if="logoTxt" :href="BASE_URL" class="logo-txt">{{logoTxt}}</a>
                <i>·</i>
                <router-link to="/alumni" class="link-home">校友服务</router-link>
            </div>
            <div v-if="indentify" @click="turn" class="fr school_friends_serve pointer">校友服务管理</div>
        </div>
    </div>
</template>

<script>
    
    export default{
        data(){
            return {
                baseUrl: process.env.BASE_URL,
                logoUrl: sessionStorage.getItem('logoUrl'),
                logoTxt: sessionStorage.getItem('logoTxt')
            }
        },
        methods:{
            turn(){
                var url = sessionStorage.getItem('manage_url');
                var host = sessionStorage.getItem('host');
                var token = sessionStorage.getItem('redirect_params');
                // console.log(url + '/admin' + token + '&host=' + host + '&routerUrl=' + '/life/alumni/alumni-list');
                // console.log(decodeURIComponent(url + '/admin' + token + '&host=' + host + '&routerUrl=' + '/life/alumni/alumni-list'));   
                window.open(decodeURIComponent(url + '/admin' + token + '&host=' + host + '&routerUrl=' + '/life/alumni/alumni-list'));   

            }
        },
        computed:{
            indentify(){
                var role = JSON.parse(sessionStorage.getItem('user_info_str')).role;
                
                for(var i=0;i<role.length;i++){
                    if(role<=3){
                        return true
                    }
                }

                return false
            }
        }

    }
</script>

<style lang="scss">
    .headder{
        background: #fff;
        height: 80px;
        box-shadow: 0 2px 4px 0 rgba(195,195,195,0.30);
    }
    .head-cont{
        padding: 15px 25px 0 25px;
        &>.pointer:hover{
            cursor:pointer;
        }
    }
    .logo-lk{
        >a{
            line-height: 40px;
        }
        >i{
            margin-right: 5px;
            font-weight: bold;
        }
        .link-home{
            font-size: 16px;
            color: #000000;
            letter-spacing: 2px;

        }
    }
    .school_friends_serve{
        margin-top:6px;
        width:124px;
        height:36px;
        background: #348EFC;
        border-radius: 3px;
        font-size: 14px;
        color: #FFFFFF;
        letter-spacing: 0;
        line-height:36px;
        text-align:center;
    }

    .train-test{
        button{
            background: #348EFC;
            border-radius: 3px;
            width: 120px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            color: #fff;
            padding: 0;
        }
        >a,>span{
            display: inline-block;
            vertical-align: top;
            line-height: 36px;
            color: #338efc;
            margin-right: 30px;
            cursor: pointer;
        }
    }
</style>